// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"cart-alert-module__wrapper___ywntK"};